import React from "react";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent, NavigationMenuLink } from "../../components/ui/navigation-menu.jsx";
import { Button } from "../../components/ui/button.jsx";
import { servicesGroups, hostingGroups } from "../mock/mock";
import { Phone, ArrowRight } from "lucide-react";
import { CalendlyModal } from "./CalendlyModal";

export const Header = () => {
  const logoUrl = "/SKYRISE-final-logo-grey.svg";

  const MenuGroup = ({ title, items }) => (
    <div className="min-w-[220px] px-4 py-3 border-l border-white/10 first:border-l-0">
      <p className="text-white/80 text-sm mb-2 uppercase tracking-wider">{title}</p>
      <ul className="space-y-2">
        {items.map((item, idx) => (
          typeof item === "string" ? (
            <li key={idx} className="text-white/70 text-sm hover:text-white transition-colors">{item}</li>
          ) : (
            <li key={idx} className="text-white/80 group cursor-pointer">
              <div className="flex items-start justify-between">
                <span className="text-sm group-hover:text-white transition-colors">{item.label}</span>
                {item.desc && <span className="text-xs text-white/50 ml-3">{item.desc}</span>}
              </div>
            </li>
          )
        ))}
      </ul>
    </div>
  );

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3">
          <img src={logoUrl} alt="SKYRISE" className="h-8 w-auto opacity-90" />
        </a>
        <nav className="hidden md:flex items-center gap-6">
          <NavigationMenu>
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuTrigger className="bg-transparent text-white/80 hover:text-white">Services</NavigationMenuTrigger>
                <NavigationMenuContent className="bg-black/90 backdrop-blur-[20px] border border-white/10 min-w-[920px] lg:min-w-[1040px] p-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">{servicesGroups.map((g) => (
                    <MenuGroup key={g.title} title={g.title} items={g.items} />
                  ))}</div>
                  <div className="p-4 border-t border-white/10 flex items-center justify-between">
                    <span className="text-white/70 text-sm">Not sure where to start?</span>
                    <a href="#contact" className="btn-primary dark-button-animate">Get Proposal <ArrowRight size={18} /></a>
                  </div>
                </NavigationMenuContent>
              </NavigationMenuItem>

              <NavigationMenuItem>
                <NavigationMenuTrigger className="bg-transparent text-white/80 hover:text-white">Hosting</NavigationMenuTrigger>
                <NavigationMenuContent className="bg-black/90 backdrop-blur-[20px] border border-white/10 min-w-[920px] lg:min-w-[1040px] p-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">{hostingGroups.map((g) => (
                    <MenuGroup key={g.title} title={g.title} items={g.items} />
                  ))}</div>
                  <div className="p-4 border-t border-white/10 flex items-center justify-between">
                    <span className="text-white/70 text-sm">Fully managed migrations available</span>
                    <a href="#hosting" className="btn-secondary dark-button-animate">Explore Plans</a>
                  </div>
                </NavigationMenuContent>
              </NavigationMenuItem>

              <NavigationMenuItem>
                <NavigationMenuLink href="#work" className="text-white/70 hover:text-white">Work</NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink href="#faq" className="text-white/70 hover:text-white">FAQ</NavigationMenuLink>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href="#contact" className="btn-secondary">Contact</a>
          <CalendlyModal trigger={({onClick}) => (<button onClick={onClick} className="btn-primary"><Phone size={18} /> Book a Call</button>)} />
        </div>
      </div>
    </header>
  );
};